import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { practitionerService } from '../../services/practitionerService';
import ReferralFormTemplate from '../../components/ReferralFormTemplate';

const ReferralForm = () => {
  const [practitionerData, setPractitionerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load Dr Touati's data from Supabase
  useEffect(() => {
    const loadPractitionerData = async () => {
      try {
        setIsLoading(true);
        const data = await practitionerService?.getBySlug('dr-touati');

        if (!data) {
          console.error('Error loading practitioner: not found');
          setError('Impossible de charger les données du praticien');
          setIsLoading(false);
          return;
        }

        setPractitionerData(data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error loading practitioner:', err);
        setError('Erreur lors du chargement');
        setIsLoading(false);
      }
    };

    loadPractitionerData();
  }, []);

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#1A1A1E] flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-[#1A1A1E] to-[#1A1A1E]" />
        <div className="text-center relative z-10">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-300 text-lg">Chargement...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error || !practitionerData) {
    return (
      <div className="min-h-screen bg-[#1A1A1E] flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-[#1A1A1E] to-[#1A1A1E]" />
        <div className="max-w-md w-full bg-white/5 backdrop-blur-sm rounded-2xl shadow-xl border border-white/10 p-8 text-center relative z-10">
          <h2 className="text-2xl font-bold text-white mb-2">Erreur</h2>
          <p className="text-gray-400 mb-6">{error || 'Impossible de charger le formulaire'}</p>
          <button
            onClick={() => window.location?.reload()}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg transition-all font-medium shadow-xl"
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`Formulaire d'Adressage - ${practitionerData?.practitioner_title} ${practitionerData?.practitioner_name} | Endodontie Exclusive`}</title>
        <meta name="description" content={`Adressez votre patient au ${practitionerData?.practitioner_title} ${practitionerData?.practitioner_name} pour un traitement endodontique spécialisé`} />
      </Helmet>
      <ReferralFormTemplate 
        practitionerData={practitionerData}
        pageTitle="Formulaire d'Adressage Endodontique"
      />
    </>
  );
};

export default ReferralForm;